
import { Fragment, useState } from "react";

import ProcessDesigner from "../ProcessDesigner/ProcessDesigner";
import processApi from "../../api/processApi";
import { dataValidator } from "../../tools/dataValidator";
import useMount from '../../hooks/useMount';
import { getLabel, getLanguage } from "../../tools/Dictionary";
import AlertModal from "../Commons/AlertModal";
import ConfirmModal from "../Commons/ConfirmModal";
import LoadingComponent from "../Commons/LoadingComponent";
import ActionButton from "../Commons/ActionButton";

import { MdContentCopy } from "react-icons/md";
import { MdDesignServices } from "react-icons/md";


const AdminProcessModal = (props) => {

  //Props
  const IsDesktop = props.IsDesktop;
  const Access = props.Access;
  const Id = props.Id;
  const OnCloseModal = props.OnCloseModal;
  //const ProductType = props.ProductType;
  const LoadData = props.LoadData;
  const OnDuplicate = props.OnDuplicate;
  const Duplicate = props.Duplicate;

  //State
  const [form, setForm] = useState(undefined);
  const [error, setError] = useState({});
  const [loading, setLoading] = useState(true);
  const [isUpdate, setIsUpdate] = useState(Id && Id != 0);
  const [designer, setDesigner] = useState(false);
  const [alert, setAlert] = useState({
    Title: "",
    Message: "",
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });
  const [confirm, setConfirm] = useState({
    Title: "",
    Message: "",
    Cancel: "",
    onCancel: () => void 0,
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });

  //Variables
  const component = "AdminProcessModal";
  const baseForm = {
    _id: 0,
    code: "",
    description: "",
    process: undefined,
    isTemplate: true,
    isActive: true,
    modifiedBy: undefined,
    status: undefined,
    duplicate: undefined
  }


  useMount(() =>
  {
    loadData();
  }, []);


  const loadData = async() => {

    if (isUpdate){

      try{

        setLoading(true);

        let response = await processApi.getProcess(Id);

        if (!response.Success)
        {

          let error = new Error()
          error.message = response.Error && response.Error.component ? getLabel(response.Error.component, response.Error.label) : undefined;

          throw error;

        }

        setForm({
          _id: response.Data._id,
          code: response.Data.code,
          description: response.Data.description,
          process: response.Data.process,
          isActive: response.Data.isActive,
          isTemplate: response.Data.isTemplate,
          usedByProduct: response.Data.usedByProduct,
          modifiedBy: response.Data.modifiedBy,
          status: response.Data.status
        });


        setLoading(false);

      }catch(err){


        setAlert({
          Title: getLabel("App", "Error"),
          Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
          Confirm: getLabel("App", "Ok"),
          onConfirm: onFatalError,
          Display: true
        });

      }

    }else{
      //Add
      setForm(baseForm);
      setLoading(false);
    }

  };

  const onFatalError = async() => {

    setAlert(alert => ({ ...alert, Display: false }));

    await LoadData(false);

    setLoading(false);

    OnCloseModal();

  };

  const onChangeCode = (e) => {

    let code = e.target.value;

    if (code.length > 30) return; //Check length

    onValidateField("code", code); //Validate field value

    setForm(form => ({
      ...form,
      code
    }));
  };

  const onChangeDescription = (e) => {

    let description = e.target.value;

    if (description.length > 100) return; //Check length

    onValidateField("description", description); //Validate field value

    setForm(form => ({
      ...form,
      description
    }));
  };

  // const onChangeProductType = (e) => {

  //   let productType = e.target.value;

  //   let foundProductType = ProductType.find(p => p._id == e.target.value);

  //   if (!foundProductType) productType = "";

  //   onValidateField("productType", productType); //Validate field value

  //   setForm(form => ({
  //     ...form,
  //     productType
  //   }));

  // };

  const onChangeActif = () => {

    setForm(form => ({
      ...form,
      isActive: !form.isActive
    }));

  };


  // Validate field
  const onValidateField = (field = "", value = "") =>
  {
    let currentError = { ...error }; // Create a copy of the error object

    let Validation = []; // Array to store validation results
    let currentValidation = [];
    let currentField = "";

    let isValid = true; // Flag to track overall validity

    currentField = "code";
    if (field == "" || field == currentField)
    {
      let currentValue = field ? value : form[currentField];

      // Validate
      currentValidation = dataValidator([
        { field: currentField, value: currentValue, listValidation: ["required", "max:30"] }
      ]);

      Validation = [...Validation, ...currentValidation];

    }

    currentField = "description"
    if (field == "" || field == currentField)
    {
      let currentValue = field ? value : form[currentField];

      // Validate
      currentValidation = dataValidator([
        { field: currentField, value: currentValue, listValidation: ["required", "max:100"] }
      ]);

      Validation = [...Validation, ...currentValidation];
    }

    // currentField = "productType"
    // if (field == "" || field == currentField)
    // {
    //   let currentValue = field ? value : form[currentField];

    //   // Validate
    //   currentValidation = dataValidator([
    //     { field: currentField, value: currentValue, listValidation: ["required"] }
    //   ]);

    //   Validation = [...Validation, ...currentValidation];
    // }

    Validation.forEach(validation =>
    {
      // Iterate over each validation result
      if (validation.valid)
      {
        currentError[validation.field] = ""; // If valid, clear the corresponding error field
      } else
      {
        currentError[validation.field] = validation.reason; // If invalid, set the error reason in the corresponding field
        isValid = false; // Set isValid to false if any validation fails
      }
    });

    setError(currentError); // Update the error state

    return isValid; // Return the overall validity flag
  };


  const onClickDelete = () => {

    setConfirm(confirm => ({
      Title: getLabel("App", "Delete"),
      Message: getLabel(component, "Are you certain you wish to proceed..."),
      Cancel: getLabel("App", "No"),
      onCancel: () => setConfirm(confirm => ({ ...confirm, Display: false })),
      Confirm: getLabel("App", "Yes"),
      onConfirm: onDelete,
      Display: true
    }));

  };

  const onDelete = async() => {

    try
    {

      setConfirm(confirm => ({ ...confirm, Display: false }))

      setLoading(true);

      let response = await processApi.deleteProcess(Id);

      if (!response.Success)
      {

        let error = new Error("");
        error.message = response.Error && response.Error.component ? getLabel(response.Error.component, response.Error.label) : undefined;

        throw error;

      }

      await LoadData(false);

      OnCloseModal();



    } catch (err)
    {
      await LoadData(false);

      setLoading(false);

      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: OnCloseModal,
        Display: true
      });

    };   

  }

  const reloadData = async() => {

    try{

      LoadData(false);
      loadData();

    }catch(err){

      throw err;
    }

  };


  //If click process designer
  const onClickProcess = async() => {

    if (!onValidateField()) return;

    if (!isUpdate){
      setConfirm(confirm => ({
        Title: getLabel("App", "Save"),
        Message: getLabel(component, "You have to save your template..."),
        Cancel: getLabel("App", "No"),
        onCancel: () => setConfirm(confirm => ({ ...confirm, Display: false })),
        Confirm: getLabel("App", "Yes"),
        onConfirm: onPreProcessSave,
        Display: true
      }));
    }else{

      setDesigner(true);

    }



  }


  const onPreProcessSave = async() => {

    try
    {

      setConfirm(confirm => ({ ...confirm, Display: false }))

      let data = await onSave();

      setForm(form => ({
        ...form,
        _id: data._id,
        process: data.process,
        modifiedBy: data.modifiedBy,
        status: data.status        
      }));

      await LoadData(false, data._id);


      setIsUpdate(true);
      setLoading(false);
      setDesigner(true);

    } catch (err)
    {

      setLoading(false);

      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });

    };
  };

  const onClickSave = async() => {

    if (!onValidateField()){

      return;
    }

    try{

      await onSave();

      await LoadData(false);

      OnCloseModal();


    }catch(err){

      setLoading(false);

    }


  }

  const onSave = async() => {

    try{

      setLoading(true);
      
      let parameters = {
        _id: form._id || 0,
        code: form.code,
        description: form.description,
        productType: form.productType,
        processHeader: form.processHeader,
        isTemplate: form.isTemplate,
        isActive: form.isActive,
        Duplicate: Duplicate
      }

      let response = await processApi.updateProcess(parameters);

      if (!response.Success){

        let error = new Error()
        error.message = response.Error && response.Error.component ? getLabel(response.Error.component, response.Error.label) : undefined;

        throw error;

      }

      return response.Data;


    }catch(err){

      setLoading(false);

      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });

      throw err;

    };

  };


  const onClickDuplicate = async() => {

    setIsUpdate(false);

    await setForm(baseForm);

    await OnDuplicate(form._id);

    document.getElementById('input_code').focus();
  };


  if (!form) return (
    <div className="page_modal_background">
      <div className="page_modal_cont" style={{ width: "900px" }}>
        <LoadingComponent
          display={loading}
          label={getLabel("App", "Loading")}
          isCover={true}
        />
        <AlertModal
          Title={alert.Title}
          Message={alert.Message}
          Confirm={alert.Confirm}
          onConfirm={alert.onConfirm}
          Display={alert.Display}
        />
        <div className="page_modal_header_cont" style={{ marginBottom: "10px" }}>
          {getLabel(component, "Process Template")}
        </div>
        <div className="page_modal_body_cont" />
        <div className="page_modal_footer_cont">
          <input
            type="button"
            className="page_button page_modal_footer_button"
            value={getLabel("App", "Close")}
            style={{ backgroundColor: "grey", maxWidth: "200px" }}
            onClick={OnCloseModal}
            disabled={loading}
          />
        </div>
      </div>
    </div>
  );


  return (
    <div className="page_modal_background">
      <div className="page_modal_cont" style={{ width: "900px" }}>
        {designer &&
          <ProcessDesigner
            IsDesktop={IsDesktop}
            ProcessId={form._id}
            Title={form.code}
            OnClose={() => setDesigner(false)}
            OnReloadData={reloadData}
          />
        }
        <LoadingComponent
          display={loading}
          label={getLabel("App", "Loading")}
          isCover={true}
        />
        <AlertModal
          Title={alert.Title}
          Message={alert.Message}
          Confirm={alert.Confirm}
          onConfirm={alert.onConfirm}
          Display={alert.Display}
        />
        <ConfirmModal
          Display={confirm.Display}
          Title={confirm.Title}
          Message={confirm.Message}
          Cancel={confirm.Cancel}
          onCancel={confirm.onCancel}
          Confirm={confirm.Confirm}
          onConfirm={confirm.onConfirm}
        />
        <div className="page_modal_header_cont" style={{ marginBottom: (Access.canWrite == true && isUpdate == true) ? "0px" : "10px" }}>
          {getLabel(component, "Process Template")} {Duplicate ? `(${getLabel("VariableDesignerModal", "Duplicate")})`:``}
        </div>
        {(Access.canWrite == true && isUpdate == true) &&
          <div className="page_modal_header_action_cont" style={{ minHeight: "40px" }}>
            <ActionButton
              IsDesktop={IsDesktop}
              Label={getLabel("VariableDesignerModal", "Duplicate")}
              Icon={MdContentCopy}
              Disabled={loading}
              OnClick={onClickDuplicate}
              buttonStyle={{ fontSize: "80%", marginRight: "10px" }}
            />
          </div>
        }
        <div className="page_modal_body_cont">
          <div className="page_modal_body_row">
            <div className="page_modal_body_col_title">
              {getLabel("T_Process", "code")}
            </div>
            <div className="page_modal_body_col_value" style={{ width: "400px" }} >
              <input
                className={"page_text_input " + (error["code"] ? "page_modal_body_col_input_error" : "")}
                value={form.code || ""}
                onChange={onChangeCode}
                type="text"
                style={{ width: "100%" }}
                disabled={!Access.canWrite || loading}
                autoFocus
                id="input_code"
              />
              {error["code"] &&
                <div className="page_modal_body_col_extra page_modal_body_col_error">
                  {error["code"]}
                </div>
              }
            </div>
          </div>
          <div className="page_modal_body_row">
            <div className="page_modal_body_col_title">
              {getLabel("T_Process", "description")}
            </div>
            <div className="page_modal_body_col_value" style={{ width: "500px" }} >
              <textarea 
                className={"page_textarea_input " + (error["description"] ? "page_modal_body_col_input_error" : "")}
                rows={3}
                value={form.description || ""}
                onChange={onChangeDescription}
                type="text"
                style={{ width: "100%" }}
                disabled={!Access.canWrite || loading}
              />
              {error["description"] &&
                <div className="page_modal_body_col_extra page_modal_body_col_error">
                  {error["description"]}
                </div>
              }
            </div>
          </div>
          <div className="page_modal_body_row">
            <div className="page_modal_body_col_title">
              {getLabel("ProcessDesigner", "Process")}
            </div>
            <div className="page_modal_body_col_value" style={{ width: "300px" }} >
              <div className="page_button page_button_design" onClick={onClickProcess}>
                <div className="page_button_design_logo">
                  <MdDesignServices />
                </div>
                <div className="page_button_design_text">
                  {getLabel("App", "Process Designer")}
                </div>
              </div>
            </div>
          </div>
          <div className="page_modal_body_row">
            <div className="page_modal_body_col_title">
              {getLabel("T_Process", "isActive")}
            </div>
            <div className="page_modal_body_col_value" style={{ width: "300px" }} >
              <label className="page_switch">
                <input
                  type="checkbox"
                  checked={form.isActive}
                  onChange={onChangeActif}
                  disabled={!Access.canWrite || loading}
                />
                <span className="page_slider round" />
              </label>
            </div>
          </div>
          {isUpdate == true && form.status && 
            <div className="page_modal_body_row">
              <div className="page_modal_body_col_title">
                {getLabel("T_Process", "status")}
              </div>
              <div className="page_modal_body_col_value" style={{ width: "600px" }} >
                {form.status.label[getLanguage()] || form.status.label["EN"] || "-"}
              </div>
            </div>
          }
          {form.usedByProduct && form.usedByProduct.length > 0 &&
          <div className="page_modal_body_row">
            <div className="page_modal_body_col_title">
              {getLabel("T_Process", "usedByProduct")}
            </div>
            <div className="page_modal_body_col_value" style={{ width: "600px" }} >
              <div className="adminprocess_usedby_cont">
                {form.usedByProduct.map((u, index) => (
                  <div className="adminprocess_usedby_item" key={index}>
                    {u.code}
                  </div>
                ))}
              </div>
            </div>
          </div>
          }
        </div>
        <div className="page_modal_footer_cont">
          <input
            type="button"
            className="page_button page_modal_footer_button"
            value={getLabel("App", "Close")}
            style={{ backgroundColor: "grey", maxWidth: "200px" }}
            onClick={(loading && !OnCloseModal) ? undefined : OnCloseModal}
            disabled={loading}
          />
          {!!Access.canWrite &&
            <Fragment>
            {isUpdate == true &&
                <input
                  type="button"
                  className="page_button page_modal_footer_button"
                  value={getLabel("App", "Delete")}
                  style={{ backgroundColor: "#b30000", maxWidth: "200px" }}
                  onClick={(loading && !OnCloseModal) ? undefined : onClickDelete}
                  disabled={loading}
                />
            }
            <input
              type="button"
              className="page_button page_modal_footer_button"
              value={getLabel("App","Save")}
              style={{ backgroundColor: "#52a3e7", maxWidth: "200px" }}
              onClick={(loading) ? undefined : onClickSave}
              disabled={loading}
            />
            </Fragment>
          }
        </div>
      </div>
    </div>
  );

};

export default AdminProcessModal;